var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Back Home")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }